/** Modal backdrop transition styles */
export const backdropSx = (open) => ({
    opacity: open ? 1 : 0,
    backdropFilter: open ? 'blur(8px)' : 'none',
    transition: 'opacity 400ms, backdrop-filter 400ms',
});

const CARD_W = 450;       // CourseVersionCard fixed width
const CARD_GAP = 12;      // horizontal gap between cards in the grid
const GRID_PAD = 8;       // grid container padding
const DIALOG_PAD = 48;    // Joy ModalDialog + DialogContent horizontal padding

/**
 * Modal dialog transition styles.
 * When `expanded` is true, the dialog grows taller + wider to fit the
 * expanded card + progress panel, then shrinks back on collapse.
 *
 * `cardCount` lets the dialog hug its content so there is no dead space
 * on the right when only a few versions exist. The dialog's own horizontal
 * padding is folded into the width so the grid rows always fit fully.
 * Beyond 3 cards the dialog stays at a fixed width and the grid scrolls.
 */
export const dialogSx = (cardCount = 0, expanded = false) => {
    const gridWidth =
        cardCount * CARD_W + Math.max(cardCount - 1, 0) * CARD_GAP + GRID_PAD * 2;
    // Cap the grid so extra cards scroll horizontally instead of stretching.
    const cappedGrid = Math.min(gridWidth, 3 * CARD_W + 2 * CARD_GAP + GRID_PAD * 2);
    // Full width the dialog needs so its content row fits exactly.
    const fitWidth = cappedGrid + DIALOG_PAD;

    const minWidth = expanded
        ? 'min(95vw, 820px)'
        : `min(95vw, ${Math.min(cappedGrid, 490) + DIALOG_PAD}px)`;
    const maxWidth = expanded
        ? 'min(95vw, 1100px)'
        : `min(95vw, ${fitWidth}px)`;

    return {
        opacity: 1,
        transition: 'opacity 300ms, max-width 400ms ease, max-height 400ms ease, min-width 400ms ease, min-height 400ms ease',
        minWidth,
        maxWidth,
        width: 'auto',
        maxHeight: expanded ? '92vh' : '90vh',
        minHeight: expanded ? '75vh' : 'auto',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
    };
};

/** Scrollbar styling for dialog content */
export const scrollbarSx = {
    overflowX: 'auto',
    overflowY: 'auto',
    '&::-webkit-scrollbar': { height: 8, width: 6 },
    '&::-webkit-scrollbar-thumb': { background: 'rgba(0,0,0,0.18)', borderRadius: 4 },
};